import MemberChangeSaVue from '@/views/member/change-sa/change-sa.vue';

const basePath = '/member/change-sa';
const role = 'member'; // 角色身份

export const M_CHANGE_SA_INDEX = 'm-change-sa';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MemberChangeSaVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_CHANGE_SA_INDEX,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/change-sa/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
